/**
 * @desc 获取单条信息
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(id: string | number, options?: any) {
  return updateResponse(
    http(URL + `/wms/firstTrialOrder/info/${id}`, {
      method: "GET",

      ...options,
    }),
  );
}
